<template>
  <div>
    <div class="discount_wrapper" v-if="isShowModal" @click="closeMsg($event)">//遮罩层
      <div class="main_discount" ref="msk">//弹窗
        <div class="main_text">
          这里是弹窗内容~~
        </div>
        <button class="confirm_btn">确定</button>
      </div>
 </div>
    <div class="TopContent">
      <div class="left">
        <div class="left_one up"  v-show="shown"  @mouseover="removeIn(1)"
            @mouseout="removeOut(1)">
          <i class="el-icon-error error"  v-show="buttonStyle"  @click="getDisplay(1)"></i>
          <p>河南省科技成果转移转化示范区绩效指标统计</p>
          <div class="inout"  @click="ToCollet('SCGZHSFQJXZBTB03')">【填报入口】</div>
        </div>
        <div class="left_one down" v-show="showB"   @mouseover="removeIn(2)"
            @mouseout="removeOut(2)">
          <i class="el-icon-error error"  v-show="buttonStyleB"  @click="getDisplay(2)"></i>
          <p>河南省职务科技成果赋权改革<br/>信息填报</p>
          <div class="inout"  @click="ToCollet('ZWKJCGFQGGTB03')">【填报入口】</div>
        </div>
        <div class="left_one three" v-show="showC"   @mouseover="removeIn(3)"
            @mouseout="removeOut(3)">
          <i class="el-icon-error error"  v-show="buttonStyleC"  @click="getDisplay(3)"></i>
          <p>河南省科技成果转移转化示范区<br/>申报建设方案</p>
          <div class="inout"  @click="ToCollet('CGZYZHSFQSBJS')">【填报入口】</div>
        </div>
      </div>
      <div class="Globalcontainer TopCarousel">
        <div class="BannerContainer">
          <el-carousel height="28.75rem" width="57.5rem" :autoplay="true">
            <el-carousel-item v-for="(item, n) in BannerList" :key="n">
              <!-- <img
                :src="item[0].img"
                @click="ToNewsInfo(item[0])"
                style="width: 100%; height: 100%"
                alt=""
              /> -->
              <el-image
                style="cursor: pointer; width: 100%; height: 100%"
                :src="item[0].img"
                fit="cover"
                @click="ToNewsInfo(item[0])"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="rightNotice">
          <ul class="TabContainer">
            <li
              v-for="(i, n) in NoticeTab"
              :class="TabIndex == n ? 'focusTab' : ''"
              :key="n"
              @click="ChangeTab(n)"
            >
              {{ i }}
            </li>
          </ul>
          <div class="NewsList">
            <li
              class="newsItem"
              v-for="(i, n) in NewsList"
              :key="n"
              @click="ToNewsInfo(i)"
            >
              <div v-if="n === 0" class="HeaderNew" v-bind:title="i.Titile">
                <div class="LeftTime">
                  <strong>{{ i.Spare1.substring(3, 5) }}</strong>
                  <br />
                  <span>{{ FirstNewsTime }}</span>
                </div>
                <div class="RightTitle">
                  <p>{{ i.Titile }}</p>
                  <span>{{ i.ShortDetails }}</span>
                </div>
              </div>
              <template v-else>
                <span class="point"></span>
                <div class="newsTitle" v-bind:title="i.Titile">
                  {{ i.Titile }}
                </div>
                <span class="newTime">{{ i.CreateTime.substring(0, 10) }}</span>
              </template>
            </li>
          </div>
          <div @click="toMoreInfo" class="toMore">查看更多></div>
        </div>
      </div>
      <div class="globalTitle">
        <div>
          <h3>数据中心</h3>
          <span style="color: #e5e5e5"> | </span>
          <span>DATA CENTER</span>
        </div>
      </div>
    </div>
    <div class="Globalcontainer dataCenter">
      <div class="LeftEntry">
        <div class="ResultSelectLeft" @click="ChangeStore(0)">
          <img
            :class="isActive == 0 ? 'AcitiveNow' : ''"
            v-show="isActive == 0"
            src="../assets/Home/组 23356@2x.png"
            alt=""
          />
          <img
            v-show="isActive !== 0"
            src="../assets/Home/组 23369@2x.png"
            alt=""
          />
          <div>
            <p>技术成果库</p>
            <span>TECHNOLOGICAL ACHIEVEMENTS</span>
          </div>
        </div>
        <div class="NeedsSelectLeft" @click="ChangeStore(1)">
          <img
            :class="isActive == 1 ? 'AcitiveNow' : ''"
            v-show="isActive == 1"
            src="../assets/Home/组 23360@2x.png"
            alt=""
          />
          <img
            v-show="isActive !== 1"
            src="../assets/Home/组 23368@2x.png"
            alt=""
          />
          <div>
            <p>技术需求库</p>
            <span>TECHNICAL DEMAND</span>
          </div>
        </div>
        <div class="ManSelectLeft" @click="ChangeStore(2)">
          <img
            :class="isActive == 2 ? 'AcitiveNow' : ''"
            v-show="isActive == 2"
            src="../assets/Home/蒙版组 19@2x.png"
            alt=""
          />
          <img
            v-show="isActive !== 2"
            src="../assets/Home/蒙版组 119@2x.png"
            alt=""
          />
          <div>
            <p>高层次人才库</p>
            <span>HIGH LEVEL TALENT</span>
          </div>
        </div>
      </div>
      <div class="MiddleData Globalcontainer">
        <div
          class="DataNum"
          :class="
            isActive == 0 ? 'TopActive' : isActive == 1 ? 'MiddleAcitve' : ''
          "
        >
          <img src="../assets/Home/组 23370@2x.png" alt="" />
          <br />
          <p v-show="isActive == 0">{{ AllData.AchievementsRow }}</p>
          <div v-show="isActive == 0">项</div>
          <p v-show="isActive == 1">{{ AllData.DemandRow }}</p>
          <div v-show="isActive == 1">项</div>
          <p v-show="isActive == 2">{{ AllData.ExpertsRow }}</p>
          <div v-show="isActive == 2">位</div>
          <button
            @click="ChangeCountry(0)"
            class="isChosed"
            @mouseover="addActive($event)"
            @mouseout="removeActive($event)"
            v-show="isActive == 0"
          >
            国内
          </button>
          <br />
          <button
            @click="ChangeCountry(1)"
            class="isChosed"
            @mouseover="addActive($event)"
            @mouseout="removeActive($event)"
            v-show="isActive == 0"
          >
            国外
          </button>
          <button
            v-show="isActive == 1"
            @click="ChangeNeedsType(7)"
            class="isChosed"
            @mouseover="addActive($event)"
            @mouseout="removeActive($event)"
          >
            高端装备制造
          </button>
          <br />
          <button
            v-show="isActive == 1"
            @click="ChangeNeedsType(10)"
            class="isChosed"
            @mouseover="addActive($event)"
            @mouseout="removeActive($event)"
          >
            新型材料
          </button>
        </div>
        <div class="StepsBox">
          <div class="contentSteps">
            <ul
              id="animation"
              v-show="isActive !== 2"
              @mouseenter="StopAnimation"
              @mouseleave="StartAnimation"
            >
              <li v-for="(i, n) in ResultList" :key="n" @click="ToMainf(i)">
                <img class="round" src="../assets/Home/椭圆 1@2x.png" alt="" />
                <p>{{ i.Title }}</p>
                <img
                  v-show="i.isHot == 1"
                  class="hot"
                  src="../assets/Home/hot@2x.png"
                  alt=""
                />
                <br />
                <span class="time">{{ i.UpdateTime }}</span>
              </li>
            </ul>
            <div v-show="isActive == 2" class="PeopleSelection">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="7">
                  <router-link to="/talent?type="
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    全部</router-link
                  >
                </el-col>
                <el-col :span="7">
                  <router-link to="/talent?type=7"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    高端装备制造</router-link
                  ></el-col
                >
                <el-col :span="7">
                  <router-link to="/talent?type=10"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    新型材料</router-link
                  ></el-col
                >
              </el-row>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="7"
                  ><router-link to="/talent?type=5"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    新一代信息技术</router-link
                  ></el-col
                >
                <el-col :span="7"
                  ><router-link to="/talent?type=11"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    新能源及新能源汽车</router-link
                  ></el-col
                >
                <el-col :span="7"
                  ><router-link to="/talent?type=13"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    现代农业</router-link
                  >
                </el-col>
              </el-row>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="7"
                  ><router-link to="/talent?type=14"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    食品工业</router-link
                  ></el-col
                >
                <el-col :span="7"
                  ><router-link to="/talent?type=8"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    节能环保</router-link
                  ></el-col
                >
                <el-col :span="7">
                  <router-link to="/talent?type=9"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    生物医药及健康</router-link
                  ></el-col
                >
              </el-row>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="7"
                  ><router-link to="/talent?type=15"
                    >
                    <!-- <img
                      src="../assets/Home/sanjiao.png"
                      style="margin-right: 5px"
                    /> -->
                    <i class="el-icon-caret-right"></i>
                    公共安全和应急处置</router-link
                  ></el-col
                >
                <el-col :span="7"
                  ><router-link to="/talent?type=16"
                    ><i class="el-icon-caret-right"></i>其他
                  </router-link>
                </el-col>
                <el-col :span="7"> </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="Entry">
        <div class="ResultSelect">
          <span>技术成果征集</span>
          <br />
          <el-button @click="ToCollet('RegistrationResults')"
            >点击进入</el-button
          >
        </div>
        <div class="NeedsSelect">
          <span>技术需求征集</span>
          <br />
          <el-button @click="ToCollet('RegistrationRequirements')"
            >点击进入</el-button
          >
        </div>
        <div class="ManSelect">
          <span>高层次人才征集</span>
          <br />
          <el-button @click="ToCollet('RegisteredTalents')">点击进入</el-button>
        </div>
      </div>
    </div>
    <div class="interview Globalcontainer">
      <div class="dockingo">
        <span id="LoginNum">{{ MsgNumList.UesrCnt }}</span
        >个
        <h2>注册机构数</h2>
      </div>
      <div class="dockingw">
        <span id="LoginNum">{{ MsgNumList.LoginCnt }}</span
        >次
        <h2>平台有效访问数</h2>
      </div>
      <div class="dockingt">
        <span id="ActionmentNum">{{ MsgNumList.AchievementCnt }}</span
        >个
        <h2>技术成果对接数</h2>
      </div>
      <div class="dockingf">
        <span id="DemondNum">{{ MsgNumList.DemandCnt }}</span
        >个
        <h2>技术需求对接数</h2>
      </div>
    </div>
    <div class="globalTitle DjDt">
      <div>
        <h3>对接动态</h3>
        <span style="color: #e5e5e5"> | </span>
        <span>DOCKING DYNAMIC</span>
      </div>
      <div>
        <el-button
          v-for="(i, n) in TypeList"
          :class="TypeActive == n ? 'NowTypeAct' : ''"
          :key="n"
          @click="loadTypeList(n)"
          >{{ i }}</el-button
        >
      </div>
    </div>
    <ul class="AllPro Globalcontainer">
      <li v-for="(i, n) in ProList" :key="n">
        <img :src="i.img" alt="" />
        <br />
        <div>
          <span>{{ i.num }}</span
          >个
        </div>
        <p>{{ i.title }}</p>
      </li>
    </ul>
    <div class="ScrollBox">
      <div class="Globalcontainer DtScroll">
        <ul class="ScrollContainer">
          <li v-for="(i, n) in TypeItemList" @click="ToMainInfo(i)" :key="n">
            <img
              v-show="i.DockingState == 3"
              src="../assets/Home/组 23459@2x.png"
              alt=""
            />
            <img
              v-show="i.DockingState == 2"
              src="../assets/Home/组 23469@2x.png"
              alt=""
            />
            <img
              v-show="i.DockingState == 1"
              src="../assets/Home/组 23471@2x.png"
              alt=""
            />

            <div>
              <span class="online" v-show="i.DockingState == 1">线上对接</span>
              <span class="commonThink" v-show="i.DockingState == 2"
                >达成意向</span
              >
              <span class="Part" v-show="i.DockingState == 3">合作签约</span>
              <span class="ScrollTitle">{{ i.Title }}</span>
              <br />
              <div>
                <i class="userName">{{ i.UserNameA }} </i><span>与</span>
                <i class="userName">{{ i.UserNameB }}</i>
              </div>
              <br />
              <span style="color: #999">{{
                i.Create_time.substring(0, 10)
              }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="Globalcontainer NewEntry">
      <img
        @click="ToSecondIndex()"
        src="../assets/Home/组 23184@2x.png"
        alt=""
      />
      <img @click="ToAssume()" src="../assets/Home/组 23187@2x.png" alt="" />
    </div>
    <div class="globalTitle">
      <div>
        <h3>热门排行</h3>
        <span style="color: #e5e5e5"> | </span>
        <span>TOP RANKING</span>
      </div>
      <img
        style="position: absolute; right: 0; top: -2.5rem"
        src="../assets/Home/蒙版组 121@2x.png"
        alt=""
      />
    </div>
    <div class="Globalcontainer Ranking">
      <div class="RankingNeeds">
        <p>技术需求排行榜</p>
        <ul>
          <li
            class="RankingItem"
            v-for="(i, n) in challengsLevel"
            :key="n"
            :class="n % 2 == 0 ? '' : 'isDark'"
            @click="toNeedsMainInf(i)"
          >
            <span
              :class="n < 3 ? 'isSpecials' : 'noisSpecials'"
              class="sorts"
              >{{ n + 1 }}</span
            >
            <span class="title" v-bind:title="i.Title">{{ i.Title }}</span>
            <span class="time">{{ i.CreateDate }}</span>
          </li>
        </ul>
      </div>
      <div class="RankingResult">
        <p>技术成果排行榜</p>
        <ul>
          <li
            class="RankingItem"
            v-for="(i, n) in ResultLevel"
            :key="n"
            :class="n % 2 == 0 ? '' : 'isDark'"
            @click="toResultMainInf(i)"
          >
            <span :class="n < 3 ? 'isSpecial' : 'noisSpecials'" class="sorts">{{
              n + 1
            }}</span>
            <span class="title" v-bind:title="i.Title">{{ i.Title }}</span>
            <span class="time">{{ i.CreateDate }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="floatWindow" v-show="FloatWindow && !ShowServeSelect">
      <div @click="ShowServeSelect = true"></div>
      <img
        src="../assets/images/组 23591@2x.png"
        @click="FloatWindow = false"
        alt=""
      />
    </div>

    <el-dialog
      title="科技金融服务满意度调查"
      :visible.sync="ShowServeSelect"
      width="30%"
      :before-close="handleClose"
      :footer="null"
    >
      <div class="ServeNotice">
        尊敬的客户：
        <br />
        <div style="text-indent: 2.5rem">
          为了给您提供更加优质的服务，增强您的满意度，我们
        </div>

        开展本次调查工作。请您下载下方附件，填写完整并盖章后，
        <br />
        于2021年12月10日前将扫描件发送至：hnsclkjjr@126.com，
        <br />
        感谢您的配合！
        <br />
        <a
          href="http://124.70.78.125:8081/doctemplate/河南省生产力促进中心客户反馈表.pdf"
          target="_blank"
          >附件：河南省生产力促进中心客户反馈表</a
        >
        <div style="text-align: right">
          河南省生产力促进中心
          <br />
          2021年11月26日
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="ShowServeSelect = false">取 消</el-button>
        <el-button type="primary" @click="ShowServeSelect = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postAction, getAction } from "@/api/api";
import {
  NewsList,
  TypeList,
  ResultList,
  AllDataNum,
  HostList,
  WechatLogin,
} from "@/api/url";
import $ from "../../public/jquery-2.1.1.js";
import { imgcommonUrl } from "../api/url.js";
export default {
  data() {
    return {
      NoticeTab: ["通知公告", "政策资讯", "产经资讯"],
      TypeList: ["全部", "线上对接", "达成意向", "合作签约"],
      TabIndex: 0,
      isActive: 0,
      IsChina: 0,
      TypeActive: 0,
      FloatWindow: true,
      ShowServeSelect: false,
      FirstNewsTime: "",
      TypeItemList: [],
      ResultLevel: [],
      challengsLevel: [],
      ResultList: [],
      NewsList: [],
      BannerList: [],
      AllData: {},
      MsgNumList: {},
      ProList: [
        {
          title: "高端装备制造",
          img: require("../assets/Home/组 23180@2x.png"),
          num: 7,
        },

        {
          title: "新型材料",
          img: require("../assets/Home/组 23180@2x(1).png"),
          num: 2,
        },
        {
          title: "新一代信息技术",
          img: require("../assets/Home/组 23180@2x(2).png"),
          num: 2,
        },

        {
          title: "现代农业",
          img: require("../assets/Home/组 23180@2x(4).png"),
          num: 2,
        },
        {
          title: "新能源及新能源汽车",
          img: require("../assets/Home/组 23180@2x(3).png"),
          num: 2,
        },
        {
          title: "食品工业",
          img: require("../assets/Home/组 23180@2x(5).png"),
          num: 2,
        },
        {
          title: "生物医药及健康",
          img: require("../assets/Home/组 23180@2x(6).png"),
          num: 2,
        },
        {
          title: "节能环保",
          img: require("../assets/Home/组 23180@2x(7).png"),
          num: 2,
        },
        {
          title: "公共安全和应急处置",
          img: require("../assets/Home/组 23180@2x(8).png"),
          num: 2,
        },
        {
          title: "其他",
          img: require("../assets/Home/组 23180@2x(9).png"),
          num: 2,
        },
      ],
      ResRankingList: [],
      leftTips: [
        "河南省科技成果转移转化示范区 绩效指标统计",
        "职务科技成果赋权改革",
      ],
      shown:true,
      buttonStyle:false,
      showB:false,
      buttonStyleB:false,
      showC:true,
      buttonStyleC:false,
    };
  },
  created() {
    //this.isWeChatLogin(); //微信登录
    this.loadNews(); // 获取通知公告列表
    this.loadTypeList(0);
    this.loadHotRank();
    this.loadResultList(0);
    this.loadAllDataNum();
    this.loadLeaveMsgTotal();
    this.GetListPictureIndex();
    this.$bus.$emit("ChangeFocus", 0);
    this.FloatWindow = false; //问卷调查默认关闭
  },

  methods: {
     // 这个是点击关闭按钮
     getDisplay(index){
      if(index==1){
        this.shown=false
      }else if(index==2){
         this. showB=false
      }else{
        this. showC=false
      }
    
    },
    // 左侧的按钮
    removeIn(index) {
      if(index==1){
        this.buttonStyle=true
      }else if (index==2){
        this.buttonStyleB=true
      }else
      {
        this.buttonStyleC=true
      }
      // $event.currentTarget.className = "isChosed1";
    },
    removeOut(index) {
      if(index==1){
        this.buttonStyle=false
      }else if(index==2){
        this.buttonStyleB=false
      }else
      {
        this.buttonStyleC=false
      }
      // $event.currentTarget.className = "isChosed1";
    },
    //按钮的切换颜色
    addActive($event) {
      $event.currentTarget.className = "isChosed1";
    },
    removeActive($event) {
      $event.currentTarget.className = "isChosed";
    },
    // isWeChatLogin() {
    //   let code = this.getQueryString("code");
    //   let data = {
    //     action: "Weixinaccess_token",
    //     code: code,
    //   };
    //   getAction(WechatLogin, data).then((res) => {
    //     if (res.status == 1) {
    //       this.getwxuserinfo(res.access_token, res.openid);
    //     }
    //   });
    // },
    // getwxuserinfo(token, openid) {
    //   let data = {
    //     action: "getweixinuserinfo",
    //     openid: openid,
    // accesstoken: token,
    //   };
    //   getAction(WechatLogin, data).then((res) => {
    //     if (res.status == 10) {
    //       localStorage.setItem("UserInfo", JSON.stringify(res));
    //       this.$router.push("/weChatLogin");
    //     } else if (res.status == 1) {
    //       localStorage.setItem("UserInfo1", JSON.stringify(res));
    //       var wxuserinfoupdate = res;
    //       wxuserinfoupdate.action = "bangdingwxuserinfo";
    //       getAction(WechatLogin, wxuserinfoupdate).then((res) => {});
    //     }
    //     // window.location.reload();
    //   });
    // },
    // getQueryString(name) {
    //   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    //   var r = window.location.search.substr(1).match(reg);
    //   if (r != null) return unescape(r[2]);
    //   return null;
    // },
    loadAllDataNum() {
      getAction(AllDataNum, { action: "GetTrCount" }).then((res) => {
        this.AllData = res[0];
      });
    },
    loadLeaveMsgTotal() {
      let data = {
        action: "Get_LeaveMsgTotal",
      };
      postAction(TypeList, this.$qs.stringify(data)).then((res) => {
        this.MsgNumList = res;
      });
    },
    loadNews() {
      let data = {
        action: "Get_InformationIndex",
        Type: "1",
        Count: "7",
      };

      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        this.NewsList = res;
        this.FirstNewsTime =
          this.NewsList[0].CreateTime.substring(0, 7).replace("-", "年") + "月";
      });
    },
    loadTzgg(n) {
      let vm = this;
      let url2 =
        "http://122.112.231.161:13500/r4QwXEGi/api/industry/category/search";
      let url1 =
        "http://122.112.231.161:13500/r4QwXEGi/api/policy/category/search";
      $.ajax({
        type: "get",
        url: n == 1 ? url1 : url2,
        data: {
          region: "",
          limit: 7,
          skip: 1,
          q: "",
        },
        datatype: "json",
        async: false,
        success: function (data) {
          vm.NewsList = [];

          data.data.forEach((item) => {
            let ZcData = {
              Titile: item.name,
              CreateTime: item.properties.发布时间,
              ShortDetails: item.properties.简介,
              Spare1: item.properties.发布时间.substring(5, 10),
              ID: item._id,
            };
            vm.NewsList.push(ZcData);
          });
          vm.FirstNewsTime =
            vm.NewsList[0].CreateTime.substring(0, 7).replace("-", "年") + "月";
          //var   dnt = eval(data.data) || [];
          // for (var i = 0; i < dnt.data.length; i++) {}
          //document.getelementbyid("listul1").innerhtml = html;

          vm.$forceUpdate();
        },
      });
    },
    loadTzgg1(n) {
      let vm = this;
      let data = {
        action: "Get_InformationTzgg",
        Type:n,
        Count: "7",
        limit:"7",
        skip:"1",
      };

      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        vm.NewsList = [];
        vm.NewsList = res.data;
        vm.FirstNewsTime =
            vm.NewsList[0].CreateTime.substring(0, 7).replace("-", "年") + "月";
      });
      
    },
    GetListPictureIndex() {
      let data = {
        action: "GetListPictureIndex",
        Type: "1",
        Count: "7",
      };
      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        this.BannerList = [];
        res.forEach((item) => {
          if (item.Picture != "") {
            let data = [
              {
                ID: item.ID,
                img: item.Picture,
              },
            ];
            this.BannerList.push(data);
          }
        });
      });
    },
    toMoreInfo() {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/AboutInform",
          query: { type: this.TabIndex },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path: this.Urls+"/cement/index.html#/AboutInform",
          query: { type: this.TabIndex },
        });
      }
    },

    ChangeTab(n) {
      this.TabIndex = n;

      if (n != 0) {
        if(n ==1 )
        {
          n =2;
        }
        else if(n==2)
        {
          n=1;
        }
        this.loadTzgg1(n);
      } else {
        this.loadNews();
      }
    },

    // 需求库 成果库筛选
    ChangeStore(n) {
      this.isActive = n;
      if (n !== 3) {
        this.loadResultList(n);
      }
    },
    ToAssume() {
      this.$router.push("/Assume");
    },
    ToNewsInfo(i) {
      console.log(i)
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        //判断设备像素宽
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/NewsInfo",
          query: {
            id: i.ID,
            type: this.TabIndex,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path:
            this.Urls+"/Mobile/index.html#/AboutNotice?data=" +
            i.ID +
            "&type=" +
            this.TabIndex,
        });
      }
    },
    ChangeCountry(n) {
      this.$router.push({ path: "/fruit", query: { ID: n } });
    },
    loadResultList(n) {
      // 需求库 成果库滚动数据
      let data = {
        action: n == 0 ? "Get_HomeAchievements" : "Get_HomeDemand",
        top: "20",
      };
      postAction(ResultList, this.$qs.stringify(data)).then((res) => {
        this.ResultList = res;
        this.$forceUpdate();
      });
    },
    loadTypeList(n) {
      this.TypeActive = n;
      let data = {
        action: "Get_LeaveMsgList",
        status: n == 0 ? "" : n,
      };
      postAction(TypeList, this.$qs.stringify(data)).then((res) => {
        this.TypeItemList = res;
      });
      let datas = {
        action: "Get_TechFieldTotal",
        status: n == 0 ? "" : n,
      };
      postAction(TypeList, this.$qs.stringify(datas)).then((res) => {
        for (var i = 0; i < res.length; i++) {
          this.ProList[i].num = res[i].Cnt;
        }
      });
    },
    loadHotRank() {
      let datas = {
        action: "Get_ChartsIndex",
        Source: "1",
      };
      let data = {
        action: "Get_ChartsIndex",
        Source: "2",
      };
      postAction(HostList, this.$qs.stringify(data)).then((res) => {
        this.challengsLevel = res.data;
      });
      postAction(HostList, this.$qs.stringify(datas)).then((res) => {
        this.ResultLevel = res.data;
      });
    },
    ToCollet(n) {
      let RealName = localStorage.getItem("RealName");
      let vm = this;
      if (RealName == "") {
        vm.$confirm("当前未登录, 是否登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$bus.$emit("dialogVisible", "true");
          })
          .catch(() => {});
      } else {
        //待修改
        window.location.href = imgcommonUrl + `/Manage/index.aspx?type=${n}`;
      }
    },

    StopAnimation() {
      // $("#animation")[0].style.animation = "none";
    },
    StartAnimation() {
      // $("#animation")[0].style.animation =
      //   "mymove " + 30 + "s" + "  linear infinite";
    },
    ToMainf(i) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        if (this.isActive == 0) {
          let routeData = this.$router.resolve({
            path: "/fruitDetail",
            query: {
              id: i.ID,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          let routeData = this.$router.resolve({
            path: "/demandDetail",
            query: {
              id: i.ID,
            },
          });
          window.open(routeData.href, "_blank");
        }
      } else {
        this.$router.push({
          path:
            this.Urls+"/Mobile/index.html#/AchievementDetail?id=" +
            i.ID +
            "&Score=" +
            5,
        });
      }
    },
    ChangeNeedsType(id) {
      this.$router.push({ path: "/demand", query: { id: id } });
    },
    ToMainInfo(i) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        if (i.Type === 2) {
          let routeData = this.$router.resolve({
            path: "/demandDetail",
            query: {
              id: i.ProjectId,
            },
          });
          window.open(routeData.href, "_blank");
        } else if (i.Type === 1) {
          let routeData = this.$router.resolve({
            path: "/fruitDetail",
            query: {
              id: i.ProjectId,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          let routeData = this.$router.resolve({
            path: "/ZbData",
            query: {
              list: i.ProjectId,
            },
          });
          window.open(routeData.href, "_blank");
        }
      } else {
        this.$router.push({
          path:
            this.Urls+"/Mobile/index.html#/NeedPoolDetail?id=" +
            i.ProjectId,
        });
      }
    },
    ToSecondIndex() {
      window.open("https://www.hnkgdh.com");
    },
    toNeedsMainInf(i) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/demandDetail",
          query: {
            id: i.ProjectID,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path:
            this.Urls+"/Mobile/index.html#/NeedPoolDetail?id=" +
            i.ProjectID,
        });
      }
    },
    toResultMainInf(i) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/fruitDetail",
          query: {
            id: i.ProjectID,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path:
            this.Urls+"/Mobile/index.html#/AchievementDetail?id=" +
            i.ProjectID +
            "&Score=" +
            5,
        });
      }
    },
    handleClose() {
      this.ShowServeSelect = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/Index";
.left{
  position: fixed;
  top: 18rem;
  left: 0.8rem;
//  right: 104rem;
width:14.2rem;
  .left_one {
    width: 100%;
    background-color: #d70f0f; /* 示例背景色 */
    border-radius: 0.2rem;
    margin-bottom: 1.5rem;
    position: relative;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 0.95rem;
    
    color: #ffffff;
    // line-height: 8rpx;
    text-align: center;
    font-style: normal;
    text-transform: none;
    .error{
      position: absolute;
      top: -0.8rem;
      right: -.5rem;
      font-size: 1.5rem;
      cursor: pointer;
      color: rgb(209, 208, 208);
    }
    p{
      padding: 0.8rem 0.4rem;
    }
    .inout {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      // font-size: 6rpx;
      color: #fff700;
      // line-height: 6rpx;
      text-align: center;
      padding-bottom: 0.8rem;
      cursor: pointer;
    }
  }
  .up{
    background: url("../assets/img/up.png");
    background-size: 100% 100%;
  }
  .down{
    background: url("../assets/img/down.png");
    background-size: 100% 100%;
  }
  .three{
    background: url("../assets/img/three.png");
    background-size: 100% 100%;
  }
}
.lefta{
  right: 105rem;
}
.floatWindow {
  position: fixed;
  width: 23.125rem;
  right: 6.25rem;
  height: 12.5rem;
  z-index: 9999;
  cursor: pointer;
  bottom: 1.25rem;
  div {
    background: url("../assets/images/wenJuan.jpg");
    width: 23.125rem;
    height: 12.5rem;
    background-size: 100% 100%;
  }
  img {
    width: 2rem;
    width: 2rem;
    position: absolute;

    top: -1rem;
    z-index: 99999;
    right: -1rem;
  }
}
.ServeNotice {
  text-align: left;
  font-size: 1rem;
  padding: 0 2.375rem;
  line-height: 2;
}
/deep/.el-carousel__indicators--horizontal {
  margin-bottom: 1.5rem;
  .el-carousel__indicator--horizontal button {
    width: 0.625rem;
    height: 0.625rem;
    background: #ffffff;
    border-radius: 50%;
    opacity: 0.4;
  }
  .el-carousel__indicator--horizontal.is-active button {
    width: 1.375rem;
    height: 0.625rem;
    background: #ffffff;
    opacity: 1;
    border-radius: 0.375rem;
  }
}
.userName {
  font-style: normal;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ScrollTitle {
  width: 17rem;
  text-align: left !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ScrollContainer {
  margin-left: 1.875rem;
  li {
    margin-right: 0.625rem;
  }
}
.Entry {
  .el-button {
    color: #7d9ed8;
    border: 1px solid #7d9ed8;
    &:hover {
      color: #2769dc;

      border: 1px solid #2769dc;
    }
  }
}
.NeedsSelect {
  .el-button {
    color: #f2a348;
    border: 1px solid #fbc68a;

    &:hover {
      color: #f8870b;
      border: 1px solid #f8870b;
    }
  }
}
.ManSelect {
  .el-button {
    color: #42d2c3;
    border: 1px solid #a1d8d2;

    &:hover {
      color: #16c4b2;

      border: 1px solid #16c4b2;
    }
  }
}
.noisSpecials {
  display: inline-block;
  width: 2.5625rem;
  height: 2.5625rem;
  text-align: center;
  line-height: 2.5625rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  /* line-height: 3.1875rem; */
  margin-left: 1rem !important;
}
</style>

